import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { basePageWrap } from '../BasePage';
import styles from './SampleLibraryPage.module.scss';
import Breadcrumbs from '../../components/Breadcrumbs';

// Components
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import HeroButtonModal from '../../components/HeroButtonModal/HeroButtonModal';
import AudioPlayerList from '../../components/AudioPlayerList';
import DownloadProductChooserModal from "../../components/DownloadProductChooserModal";


const SampleLibraryPage = ({
    hero,
    breadcrumbs = {
        links: [],
    },
    settings = {
        header: {},
        footer: {},
    },
    sampleInstruments,
    compatibleProducts,
    selectedProductId,
    downloadOptions,
}) => {
    return (
        <div className={styles['SampleLibraryPage']}>
            <Header {...settings.header} />
            <div className={styles['SampleLibraryPage__Container']}>
                <div className={styles['SampleLibraryPage__Breadcrumbs']}>
                    <Breadcrumbs {...breadcrumbs} />
                </div>
                <main>
                    {hero && <HeroButtonModal {...hero} modal={{ buttonText: `Download ${hero.title}` }}>
                        <DownloadProductChooserModal {...downloadOptions} title={hero.title} />
                    </HeroButtonModal>}

                    {sampleInstruments && sampleInstruments.length && (
                        <AudioPlayerList
                            selectedProductId={selectedProductId}
                            productList={compatibleProducts}
                            download={true}
                            column={true}
                            items={sampleInstruments}
                        />
                    )}

                </main>
            </div>
            <Footer {...settings.footer} />
        </div>
    );
};

SampleLibraryPage.propTypes = {
    settings: PropTypes.object,
    hero: PropTypes.object,
    breadcrumbs: PropTypes.object,
    sampleInstruments: PropTypes.array,
    selectedProductId: PropTypes.number,
    compatibleProducts: PropTypes.shape({
        activeProducts: PropTypes.array,
        legacyProducts: PropTypes.array
    }),
    downloadOptions: PropTypes.shape({
        products: PropTypes.array,
        legacyProducts: PropTypes.array
    })
};

export default basePageWrap(SampleLibraryPage);
